import { CanvasDisplay } from "./map.canvas.display";
import { Context2DTileMap } from "./map.context2d";
import { InputController, InputsNavigationController } from "../inputs";
export class CanvasMap extends Context2DTileMap {
    constructor(display, options, nav) {
        if (display instanceof HTMLCanvasElement) {
            display = new CanvasDisplay(display);
        }
        super(display, nav);
        this._context = display.getContext();
        this._inputController = options?.inputController ?? new InputController(display.canvas);
        this._navigationManager = options?.navigationManager ?? new InputsNavigationController(this._inputController, this);
    }
    _doValidate() {
        super._doValidate();
        const ctx = this._getContext2D();
        if (ctx) {
            this.draw(ctx);
        }
    }
    _getContext2D() {
        return this._context;
    }
}
//# sourceMappingURL=map.canvas.js.map